export default {"src":"/_next/static/media/ADSK.65b3aebd.svg","height":18,"width":18};